import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";
import { Ff } from "@src/types.generated";

const useDarkThemeEnabled = (): boolean =>
  useFeatureFlag(Ff.DashboardDarkTheme);

export default useDarkThemeEnabled;
